import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-howwork',
  templateUrl: './howwork.component.html',
  styleUrls: ['./howwork.component.css']
})
export class HowworkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
